module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/parent.component.html
// module id = ../../../../../src/app/parent/parent.component.html
// module chunks = main